// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimQuestion from '@deere/cps-it.warranty-model-factory/lib/claim-question';
import ClaimQuestionDropdownContainer from '../../../../shared/components/claim-fields/claim-question-dropdown-container';

const SurveyQuestionsItem = props =>
    <li className='question-row'>
        <div className='question'>{props.question.value}</div>
        <ClaimQuestionDropdownContainer
            {...props}
            className='answer'
            isEditable={props.isEditable}
            list={props.questionsRequiredOptions}
            selectedValue={props.question}
        />
    </li>;

SurveyQuestionsItem.displayName = 'SurveyQuestionsItem';
SurveyQuestionsItem.propTypes = {
    isEditable: PropTypes.bool.isRequired,
    question: PropTypes.instanceOf(ClaimQuestion).isRequired,
    questionsRequiredOptions: PropTypes.arrayOf(PropTypes.instanceOf(ClaimQuestion)).isRequired
};

export default SurveyQuestionsItem;



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/components/survey-questions/survey-questions-item.js